import Vue from 'vue'
import { Tooltip } from 'bootstrap-5'
import focus from './focus'
import dropdown from './dropdown'
import collapse from './collapse'

Vue.directive('focus', focus)
Vue.directive('dropdown', dropdown)
Vue.directive('collapse', collapse)

Vue.directive('auto-height', {

  inserted: (el) => {
    function resize () {
      this.style.height = 'auto'

      if (this.scrollHeight) {
        this.style.height = `${this.scrollHeight}px`
      }
    }

    el.addEventListener('input', resize, false)

    resize.call(el)
  }
})

const tooltipDirective = (el, { value, modifiers }) => {
  const placement = modifiers.top ? 'top' : (modifiers.bottom ? 'bottom' : (modifiers.left ? 'left' : 'right'))
  const fallbackPlacements = modifiers.force ? [] : ['top', 'bottom', 'left', 'right']

  new Tooltip(el, {
    title: value || '',
    placement,
    container: 'body',
    trigger: 'hover',
    fallbackPlacements
  })
}

Vue.directive('tooltip', {
  bind: tooltipDirective,
  update: tooltipDirective,
  unbind (el) {
    const tooltip = Tooltip.getInstance(el)

    tooltip.dispose()
  }
})
